// <s-free-shipping> eases its progress bar from the previous cart total to the new one.
// The cart partials re-render it after every cart change; the last progress per instance
// id is remembered so the bar glides instead of jumping. CSS honors reduced motion.
const lastProgress = new Map();

class SFreeShipping extends HTMLElement {
  static observedAttributes = ['data-progress'];

  connectedCallback() {
    this.#update();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this.isConnected && oldValue !== newValue) this.#update();
  }

  #update() {
    const target = Number(this.dataset.progress) || 0;
    const previous = lastProgress.get(this.id);
    lastProgress.set(this.id, target);
    if (previous === undefined || previous === target) {
      this.style.setProperty('--fs-progress', String(target));
      return;
    }
    this.style.setProperty('--fs-progress', String(previous));
    // Force a style flush so the transition runs from the previous width.
    void this.offsetWidth;
    requestAnimationFrame(() => this.style.setProperty('--fs-progress', String(target)));
  }
}

if (!customElements.get('s-free-shipping')) {
  customElements.define('s-free-shipping', SFreeShipping);
}
